// Insight (/org/insight...): the overview, the goals cascade, the workload
// heat map and the portfolio. In the app shell (OrgShell, via InsightFrame).
// The old addresses forward here.
import { extra, moved, page, type AreaRoute } from "../../routes/types";

export const routes: AreaRoute[] = [
  extra("/org/insight", page(() => import("./pages/InsightOverviewPage"), "InsightOverviewPage")),
  extra("/org/insight/goals", page(() => import("./pages/InsightGoalsPage"), "InsightGoalsPage")),
  extra("/org/insight/workload", page(() => import("./pages/InsightWorkloadPage"), "InsightWorkloadPage")),
  extra("/org/insight/portfolio", page(() => import("./pages/InsightPortfolioPage"), "InsightPortfolioPage")),
  moved("/org/goals", "/org/insight/goals"),
  moved("/org/analytics", "/org/insight"),
  moved("/org/workload", "/org/insight/workload"),
];
